import React from 'react';
import { Navigate } from 'react-router-dom';
import Analytics from '../pages/analytics';

const Planning = React.lazy(() => import('../pages/planning'));
const PlanningCalendar = React.lazy(() => import('../pages/planning/calendar'));
const PlatformAnalytics = React.lazy(() => import('../pages/analytics/platforms'));
const ListCalendar = React.lazy(() => import('../components/planning/list'));
const BrandsSettings = React.lazy(() => import('../pages/brands/brand-settings'));
const Brands = React.lazy(() => import('../pages/brands'));
const Connections = React.lazy(() => import('../pages/brands/connections'));
const UserSettings = React.lazy(() => import('../pages/user-settings'));
const BillingForm = React.lazy(() => import('../pages/user-settings/plans-and-billing'));
const UserAccount = React.lazy(() => import('../pages/user-settings/account'));
const UserAccess = React.lazy(() => import('../pages/user-settings/access'));
const ChangePassword = React.lazy(() => import('../pages/ChangePassword'));


export const AdminRoutes = [
    { path: 'analytics', element: <Analytics />, name: 'Analytics', title: 'Analytics', icon: 'Analytics', children: [
        { path: '', element: <Navigate to="facebook" replace />, name: 'Facebook', title: 'Facebook', icon: 'Facebook' },
        { path: ':platformName', element: <PlatformAnalytics />, name: 'platfromName', },
       ] },
    {
        path: 'planning',
        element: <Planning />,
        name: 'Planning',
        title: 'Planning',
        icon: 'CalendarMonth',
        children: [
            {
                path: '',
                name: '',
                element: <Navigate to="calendar" replace />,
            },
            {
                path: 'calendar',
                name: 'Calendar',
                element: <PlanningCalendar />,
            },
            {
                path: 'list',
                name: 'List',
                element: <ListCalendar />,
            },
        ],
    },
    {
        path: 'brands',
        element: <Brands />,
        name: 'Brands',
        title: 'Brands',
        icon: 'SettingsIcon',
        children: [
            {
                path: '',
                name: '',
                element: <Navigate to="brandSettings" replace />,
            },
            {
                path: 'brandSettings',
                name: 'Brand Settings',
                element: <BrandsSettings />,
            },
            {
                path: 'connections',
                name: 'connections',
                element: <Connections />,
            },
        ],
    },
    {
        path: 'user-settings',
        element: <UserSettings />,
        name: 'User Settings',
        title: 'User Settings',
        icon: 'SettingsIcon',
        children: [
            {
                path: '',
                name: '',
                element: <Navigate to="account" replace />,
            },
            {
                path: 'account',
                name: 'Account',
                element: <UserAccount />,
            },
            {
                path: 'access',
                name: 'Access',
                element: <UserAccess />,
            },
            {
                path: 'plans-and-billing',
                name: 'Plans and Billing',
                element: <BillingForm />,
            },
        ],
    },
    {
        path: 'change-password',
        name: 'Change Password',
        title: 'Change Password',
        element: <ChangePassword/>,
    },
];
